import { render, staticRenderFns } from "./StudentProfiles.vue?vue&type=template&id=5f117ad6&"
import script from "./StudentProfiles.vue?vue&type=script&setup=true&lang=js&"
export * from "./StudentProfiles.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./StudentProfiles.vue?vue&type=style&index=0&id=5f117ad6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports